import React from 'react'
import type { Icon } from 'shared/utils'
import { transformations } from 'shared/utils'

const Chevron = (props: Icon) => {
    const {
        color = 'white',
        size = 24,
        className = 'chevron',
        direction = 'right',
        ...otherProps
    } = props

    return (
        <svg
            className={className}
            width={size}
            height={size}
            fill={color}
            style={{
                transform: transformations[direction],
                transition: 'transform 300ms'
            }}
            {...otherProps}
            viewBox="0 0 24 24"
            preserveAspectRatio="none">
            <path
                d="M8.295 17.295l4.58-4.59-4.58-4.59 1.41-1.41 6 6-6 6z"
                fillRule="evenodd"
            />
        </svg>
    )
}

export { Chevron }
